import gql from 'graphql-tag'
import { splitError } from '@/helper/splitError'
import { getProvider } from '@/apollo'

const BookTariffOptionsModule = {
  namespaced: true,
  state: {
    processId: null,
    bookTariffoptionDocumentUrl: null
  },
  actions: {
    async bookTariffoption ({ commit, state, getters, rootGetters }, { tariffoptionId }) {
      commit('clearMessages', {}, { root: true })
      const apolloClient = getProvider().defaultClient
      return apolloClient.mutate({
        mutation: gql`mutation tariffOptions ($bookTariffoptionInput: BookTariffoptionInput!) {
          bookTariffoption (bookTariffoption: $bookTariffoptionInput){
            success,
            processId,
            bookTariffoptionDocumentUrl
          }
        }`,
        variables: {
          bookTariffoptionInput: {
            tariffoptionId: tariffoptionId
          }
        }
      }).then((response) => {
        commit('processId', response.data.bookTariffoption.processId)
        commit('storeBookTariffoptionDocumentUrl', response.data.bookTariffoption.bookTariffoptionDocumentUrl)
        return response.data.bookTariffoption
      }).catch((error) => {
        commit('processId', null)
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    },
    async confirmTariffoption ({ commit, state }) {
      commit('clearMessages', {}, { root: true })
      const apolloClient = getProvider().defaultClient

      return apolloClient.mutate({
        mutation: gql`mutation tariffOptions ($confirmTariffoptionBookingInput: ConfirmTariffoptionBookingInput!) {
          confirmTariffoptionBooking (confirmTariffoptionBooking: $confirmTariffoptionBookingInput){
            success
          }
        }`,
        variables: {
          confirmTariffoptionBookingInput: {
            processId: state.processId
          }
        }
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
        throw error // damit in der FE Komponente success nicht auf true gesetzt wird
      })
    }
  },
  mutations: {
    processId (state, id) {
      state.processId = id
    },
    storeBookTariffoptionDocumentUrl: (state, bookTariffoptionDocumentUrl) => {
      state.bookTariffoptionDocumentUrl = bookTariffoptionDocumentUrl
    },
    resetState (state) {
      state.bookTariffoptionDocumentUrl = null
      state.processId = null
    }
  },
  getters: {
    getProcessId: state => {
      return state.processId
    },
    bookTariffoptionDocumentUrl: state => {
      return state.bookTariffoptionDocumentUrl
    }
  }
}

export {
  BookTariffOptionsModule
}
